import axios from 'axios'

// Forgot Password
const ForgotPassword = async ({params}) => {
  const response = await axios.post('/api/forgot-password', params)
  return response.data
}

// Reset Password
const ResetPassword = async ({params}) => {
  const response = await axios.post(`/api/reset-password`, params)
  return response.data
}

const PasswordService = {
  ForgotPassword,
  ResetPassword,
}

export default PasswordService
